<div class="info-wrap">

  <div class="kan-container">

    <!-- LEFT: Information Panel -->
    <div class="kan-info">
      <span class="badge">Neural Architecture</span>
      <h1>Kolmogorov–Arnold <span>Networks</span></h1>
      <div class="divider"></div>

      <p>
        <strong>KAN</strong> (Kolmogorov-Arnold Networks) is a novel neural network architecture
        inspired by the <em>Kolmogorov-Arnold representation theorem</em>. Unlike traditional
        MLPs that place fixed activation functions on nodes, KANs place
        <strong>learnable activation functions on edges</strong>.
      </p>

      <div class="tag-row">
        <span class="tag">Deep Learning</span>
        <span class="tag">Spline Functions</span>
        <span class="tag">Interpretability</span>
        <span class="tag">AI Research</span>
        <span id="spline" class="tag"><a href="https://b-spline-site.onrender.com/bspline.html" target="_blank">B-Splines</a></span>
      </div>
    </div>

    <!-- RIGHT: Image Panel -->
    <div class="kan-image">
      <span class="image-label">KAN Architecture Diagram</span>
      <img
        src="../../../kan_classification.gif"
        alt="Kolmogorov-Arnold Network Architecture Diagram"
      />
      <p class="image-caption">
        A KAN network where learnable univariate functions are placed on each edge,
        replacing traditional fixed activation functions at nodes.
      </p>
    </div>

  </div>


  <!-- Quick Facts -->
  <div class="facts-strip">
    <div class="fact-item" *ngFor="let f of facts">
      <span class="fact-icon">{{ f.icon }}</span>
      <div>
        <div class="fact-label">{{ f.label }}</div>
        <div class="fact-value">{{ f.value }}</div>
      </div>
    </div>
  </div>


   <section class="section">
    <h2 class="section-title"></h2>

    <div class="model-cards">

      <div class="mcard mcard-cnn">
        <div class="mcard-top">
          <span class="mcard-icon"></span>
          <h3>KAN can approximate any function</h3>
        </div>
        <p>
          See how <strong>KAN</strong> approximates Symbolic functions. ensures that KAN can learn any function, not just those in the training set. This is a direct consequence of the Kolmogorov–Arnold representation theorem.
        </p>
        <div class="mcard-tag">based on Theory of Approximation</div>
      </div>

      <div class="mcard mcard-loss">
        <!-- <div class="mcard-top">
          <span class="mcard-icon">🔬</span>
          <h3>KAN</h3>
        </div>
        <p>
          <strong>Kolmogorov–Arnold Networks</strong> replace conventional
          node-level activation functions with <em>learnable, spline-based
          functions on edges</em>. Grounded in the Kolmogorov–Arnold
          representation theorem, KAN offers unprecedented interpretability
          alongside competitive accuracy.
        </p>
        <div class="mcard-tag">New Architecture · 2024</div> -->
        <!-- <img src="../../../modelcomparisonchart.png" alt="demo"/> -->
      </div>
      
      




    </div>
  </section>


  <section class="section">
    <h2 class="section-title"></h2>

    <div class="model-cards">
      <div class="mcard mcard-perceptron">
        <!-- <div class="mcard-top">
          <span class="mcard-icon">🔬</span>
          <h3>KAN</h3>
        </div>
        <p>
          <strong>Kolmogorov–Arnold Networks</strong> replace conventional
          node-level activation functions with <em>learnable, spline-based
          functions on edges</em>. Grounded in the Kolmogorov–Arnold
          representation theorem, KAN offers unprecedented interpretability
          alongside competitive accuracy.
        </p>
        <div class="mcard-tag">New Architecture · 2024</div> -->
        <!-- <img src="../../../modelcomparisonchart.png" alt="demo"/> -->
      </div>

      <div class="mcard mcard-cnn">
        <div class="mcard-top">
          <span class="mcard-icon"></span>
          <h3>Perceptron model tries to approximate functions</h3>
        </div>
        <p>
          see how a simple perceptron model tries to approximate the same function. Notice how it fails to capture the complexity of the function, while KAN can do it with ease.
        </p>
        <div class="mcard-tag">based on Theory of Approximation</div>
      </div>

      
      
      




    </div>
  </section>


  <h3 style="text-align:center;color:var(--blue);">Learn by doing: Explore KAN Playground</h3>

  <div class="browser-wrapper">

    <!-- Title Bar with Traffic Lights -->
    <div class="browser-title-bar">
      <span class="dot red"></span>
      <span class="dot yellow"></span>
      <span class="dot green"></span>
    </div>

    <!-- Tab Bar -->
    <div class="browser-tab-bar">

      <!-- Active Tab -->
      <div class="browser-tab active">
        <img
          class="tab-favicon"
          src="https://www.google.com/s2/favicons?domain=wikipedia.org"
          alt="favicon"
        />
        <span>KAN — Wikipedia</span>
        <span class="tab-close">&#x2715;</span>
      </div>

      <!-- Inactive Tab -->
      <div class="browser-tab inactive">
        <img
          class="tab-favicon"
          src="https://www.google.com/s2/favicons?domain=github.com"
          alt="favicon"
        />
        <span>GitHub</span>
        <span class="tab-close">&#x2715;</span>
      </div>

      <!-- New Tab Button -->
      <button class="new-tab-btn" title="New Tab">&#43;</button>

    </div>

    <!-- Address Bar -->
    <div class="browser-address-bar">
      <button class="browser-nav-btn" title="Back">&#8592;</button>
      <button class="browser-nav-btn" title="Forward">&#8594;</button>
      <button class="browser-nav-btn" title="Reload">&#8635;</button>

      <div class="address-input-wrapper">
        <span class="lock-icon">&#128274;</span>
        <input
          type="text"
          value="https://en.wikipedia.org/wiki/Kolmogorov%E2%80%93Arnold_Networks"
          readonly
        />
      </div>

      <button class="browser-menu-btn" title="Menu">&#8942;</button>
    </div>

    <!-- IFrame Content -->
    <iframe
      class="browser-content"
      src="https://b-spline-site.onrender.com/KAN_visualization.html"
      title="KAN Wikipedia Page"
      sandbox="allow-scripts allow-same-origin"
    ></iframe>

  </div>
  <!-- Main Grid -->
  <section class="section">
    <h2 class="section-title">✨ Advantages</h2>

    <div class="adv-grid">
      <div class="adv-card"
           *ngFor="let a of advantages"
           [style.background]="a.color">
        <span class="adv-icon">{{ a.icon }}</span>
        <h4>{{ a.title }}</h4>
        <p>{{ a.desc }}</p>
      </div>
    </div>
  </section>
</div>